module.exports = __webpack_public_path__ + "img/bg_left.9a8093ef.svg";